export const LoadingDots = () => (
  <ol className="loading-screen__dots dots-container" aria-hidden="true">
    <li />
    <li />
    <li />
  </ol>
);
